/*
 * Referral Messages
 *
 * This contains all the text for the Referral component.
 */
import { defineMessages } from 'react-intl';

export const scope = 'kamereo.containers.Referral';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Giới thiệu bạn bè',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: 'Giới thiệu bạn bè đăng ký Kamereo để cùng nhận 5 voucher 100,000đ.',
  },
  subDescription: {
    id: `${scope}.subDescription`,
    defaultMessage: 'Không giới hạn số lượt giới thiệu - càng nhiều bạn bè, càng nhiều ưu đãi.',
  },
  viewDetail: {
    id: `${scope}.viewDetail`,
    defaultMessage: 'Xem chi tiết chương trình',
  },
  termPolicy: {
    id: `${scope}.termPolicy`,
    defaultMessage: 'xem điều khoản & điều kiện',
  },
  yourReferralCode: {
    id: `${scope}.yourReferralCode`,
    defaultMessage: 'Mã giới thiệu của bạn',
  },
  referralCodeLabel: {
    id: `${scope}.referralCodeLabel`,
    defaultMessage: 'Mã giới thiệu',
  },
  orShareLink: {
    id: `${scope}.orShareLink`,
    defaultMessage: 'Hoặc chia sẻ link giới thiệu',
  },
  copy: {
    id: `${scope}.copy`,
    defaultMessage: 'Sao chép',
  },
  businessesReferred: {
    id: `${scope}.businessesReferred`,
    defaultMessage: 'Doanh nghiệp được giới thiệu',
  },
  instructor: {
    id: `${scope}.instructor`,
    defaultMessage: 'Hướng dẫn tham gia',
  },
  instructorStep1: {
    id: `${scope}.instructorStep1`,
    defaultMessage: 'Chia sẻ mã giới thiệu',
  },
  instructorStep1Description: {
    id: `${scope}.instructorStep1Description`,
    defaultMessage: 'Gửi mã hoặc link cho bạn bè đang kinh doanh F&B.',
  },
  instructorStep2: {
    id: `${scope}.instructorStep2`,
    defaultMessage: '"Bạn mới" đăng ký tài khoản',
  },
  instructorStep2Description: {
    id: `${scope}.instructorStep2Description`,
    defaultMessage: '"Bạn mới" tạo tài khoản và nhập mã giới thiệu của bạn.',
  },
  instructorStep3: {
    id: `${scope}.instructorStep3`,
    defaultMessage: 'Kamereo xác minh',
  },
  instructorStep3Description: {
    id: `${scope}.instructorStep3Description`,
    defaultMessage: 'Kamereo xác minh doanh nghiệp và cấp tài khoản.',
  },
  instructorStep4: {
    id: `${scope}.instructorStep4`,
    defaultMessage: '"Bạn mới" đặt đơn đầu tiên',
  },
  instructorStep4Description: {
    id: `${scope}.instructorStep4Description`,
    defaultMessage: 'Hoàn tất đơn đầu tiên (giao thành công, không huỷ/trả).',
  },
  instructorStep5: {
    id: `${scope}.instructorStep5`,
    defaultMessage: 'Cùng nhận thưởng',
  },
  instructorStep5Description: {
    id: `${scope}.instructorStep5Description`,
    defaultMessage: 'Cả hai đều nhận được voucher mua hàng tại Kamereo.',
  },
  copySuccessfully: {
    id: `${scope}.copySuccessfully`,
    defaultMessage: 'Sao chép thành công',
  },
  referralListTitle: {
    id: `${scope}.referralListTitle`,
    defaultMessage: 'Danh sách đã giới thiệu',
  },
  colCompanyName: {
    id: `${scope}.colCompanyName`,
    defaultMessage: 'Tên doanh nghiệp',
  },
  colRegistrationDate: {
    id: `${scope}.colRegistrationDate`,
    defaultMessage: 'Ngày đăng ký',
  },
  colStatus: {
    id: `${scope}.colStatus`,
    defaultMessage: 'Trạng thái',
  },
  colVoucherValue: {
    id: `${scope}.colVoucherValue`,
    defaultMessage: 'Tổng giá trị voucher được nhận',
  },
  statusRewarded: {
    id: `${scope}.statusRewarded`,
    defaultMessage: 'Đã nhận thưởng',
  },
  statusSubmitted: {
    id: `${scope}.statusSubmitted`,
    defaultMessage: 'Đã đăng ký',
  },
  or: {
    id: `${scope}.or`,
    defaultMessage: 'hoặc',
  },
  SUBMITTED: {
    id: `${scope}.SUBMITTED`,
    defaultMessage: 'Đã đăng ký',
  },
  QUALIFIED: {
    id: `${scope}.QUALIFIED`,
    defaultMessage: 'Tiền hàng > 400K',
  },
  VERIFIED: {
    id: `${scope}.VERIFIED`,
    defaultMessage: 'Đã xác thực',
  },
  PENDING: {
    id: `${scope}.PENDING`,
    defaultMessage: 'Đã có tài khoản',
  },
  REWARDED: {
    id: `${scope}.REWARDED`,
    defaultMessage: 'Đã phát thưởng',
  },
  REJECTED: {
    id: `${scope}.REJECTED`,
    defaultMessage: 'Đã từ chối',
  },
  ORDERED: {
    id: `${scope}.ORDERED`,
    defaultMessage: 'Đã có đơn hàng',
  },
});
